/**
 * Created by Анжелика on 23.08.2017.
 */
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';

export const REGISTER_USER = 'REGISTER_USER';
export const CANCEL_REGISTRATION = 'CANCEL_REGISTRATION';
export const REGISTRATION_REQUEST = 'REGISTRATION_REQUEST';
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
export const REGISTRATION_FAILED = 'REGISTRATION_FAILED';

export const GET_USER_DATA_REQUEST = 'USER_DATA_REQUEST';
export const GET_USER_DATA_SUCCESS = 'USER_DATA_SUCCESS';
export const GET_USER_DATA_FAILED = 'USER_DATA_FAILED';
export const USER_DATA_CLEAR = 'USER_DATA_CLEAR';
export const SAVE_USER_CONFIG = 'SAVE_USER_CONFIG';
export const LOAD_USER_CONFIG = 'LOAD_USER_CONFIG';
export const UPDATE_USER_ACTIVITY_REQUEST = 'UPDATE_USER_ACTIVITY_REQUEST';
export const UPDATE_USER_ACTIVITY_SUCCESS = 'UPDATE_USER_ACTIVITY_SUCCESS';
export const UPDATE_USER_ACTIVITY_FAILED = 'UPDATE_USER_ACTIVITY_FAILED';
export const START_SEND_USER_ACTIVITY = 'START_SEND_USER_ACTIVITY';
export const STOP_SEND_USER_ACTIVITY = 'STOP_SEND_USER_ACTIVITY';

export const GET_GENRES_REQUEST = 'GET_GENRES_REQUEST';
export const GET_GENRES_SUCCESS = 'GET_GENRES_SUCCESS';
export const GET_GENRES_FAILED = 'GET_GENRES_FAILED';
export const SET_GENRE_FILTER = 'SET_GENRE_FILTER';
export const RESET_GENRE_FILTER = 'RESET_GENRE_FILTER';

export const GET_CHANNELS_REQUEST = 'GET_CHANNELS_REQUEST';
export const GET_CHANNELS_SUCCESS = 'GET_CHANNELS_SUCCESS';
export const GET_CHANNELS_FAILED = 'GET_CHANNELS_FAILED';
export const SET_CHANNEL_ACTIVE = 'SET_CHANNEL_ACTIVE';
export const RESET_CHANNEL_ACTIVE = 'RESET_CHANNEL_ACTIVE';
export const MARK_AS_FAVORITE = 'MARK_AS_FAVORITE';

export const GET_CHANNEL_LINK_REQUEST = 'GET_CHANNEL_LINK_REQUEST';
export const GET_CHANNEL_LINK_SUCCESS = 'GET_CHANNEL_LINK_SUCCESS';
export const GET_CHANNEL_LINK_FAILED = 'GET_CHANNEL_LINK_FAILED';

export const SHOW_CHANNEL_FRAME = 'SHOW_CHANNEL_FRAME';
export const SHOW_PLAYER_FRAME = 'SHOW_PLAYER_FRAME';
export const SHOW_USERDATA_FRAME = 'SHOW_USERDATA_FRAME';

export const PLAY_VIDEO = 'PLAY_VIDEO';
export const PAUSE_VIDEO = 'PAUSE_VIDEO';
export const MUTE_VIDEO = 'MUTE_VIDEO';
export const CHANGE_VOLUME_VIDEO = 'CHANGE_VOLUME_VIDEO';
export const CHANGE_QUALITY_VIDEO = 'CHANGE_QUALITY_VIDEO';
export const EXPAND_VIDEO = 'EXPAND_VIDEO';
export const COLLAPSE_VIDEO = 'COLLAPSE_VIDEO';
export const SET_HLS_LEVELS = 'SET_HLS_LEVELS';
export const SET_HLS_LEVEL_CURRENT = 'SET_HLS_LEVEL_CURRENT';
export const RESET_STATE_VIDEO = 'RESET_VIDEO';
export const SET_ERROR_VIDEO = 'SET_ERROR_VIDEO';

export const EPG_DAY_REQUEST = 'EPG_DAY_REQUEST';
export const EPG_DAY_SUCCESS = 'EPG_DAY_SUCCESS';
export const EPG_DAY_FAILED = 'EPG_DAY_FAILED';
export const EPG_RESET_DAYS = 'EPG_RESET_DAYS';
export const EPG_UPDATE_START = 'EPG_UPDATE_START';
export const EPG_TODAY_UPDATE = 'EPG_TODAY_UPDATE';
export const EPG_UPDATE_STOP = 'EPG_UPDATE_STOP';

export const CHANNEL_CARDS_ADD = 'CHANNEL_CARDS_ADD';
export const CLEAR_CHANNEL_CARDS = 'CLEAR_CHANNEL_CARDS';
export const LOAD_CHANNEL_CARDS_USER_CONFIG = 'LOAD_CHANNEL_CARDS_USER_CONFIG';

export const ADD_FAVORITE_REQUEST = 'ADD_FAVORITE_REQUEST';
export const ADD_FAVORITE_SUCCESS = 'ADD_FAVORITE_SUCCESS';
export const ADD_FAVORITE_FAILED = 'ADD_FAVORITE_FAILED';
export const DELETE_FAVORITE_REQUST = 'DELETE_FAVORITE_REQUEST';
export const DELETE_FAVORITE_SUCCESS = 'DELETE_FAVORITE_SUCCESS';
export const DELETE_FAVORITE_FAILED = 'DELETE_FAVORITE_FAILED';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js